import { render, staticRenderFns } from "./PreonboardingLifecycle.vue?vue&type=template&id=2050be34"
import script from "./PreonboardingLifecycle.vue?vue&type=script&lang=js"
export * from "./PreonboardingLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports